import * as uuid from 'uuid';
import { isUUID } from '../utilities';

export default class Site {

    static defaultValues = {
        archived: false,
    };

    id: string;
    name: string;
    siteTemplate: string;
    archived: boolean;

    static getInstanceFromObject(initializationData: any) {

        if (typeof initializationData !== 'object') {
            throw new Error('The initialization data must be an object');
        }

        // Seed all the default values into the object if they don't exist
        for (const defaultKey in Site.defaultValues) {
            if (!initializationData.hasOwnProperty(defaultKey)) {
                initializationData[defaultKey] = Site.defaultValues[defaultKey];
            }
        }

        // Begin validation

        // ID validation
        if (initializationData.hasOwnProperty('id')) {

            if (!isUUID(initializationData.id)) {
                throw new Error('Invalid ID');
            }
        }

        // Name validation
        if (!initializationData.hasOwnProperty('name')) {
            throw new Error('The name is required');
        }

        if (typeof initializationData.name !== 'string' || initializationData.name.trim().length === 0) {
            throw new Error('Invalid name');
        }

        // Type validation
        if (!initializationData.hasOwnProperty('siteTemplate') || typeof initializationData.siteTemplate === 'undefined' ||
            initializationData.siteTemplate === null) {
            throw new Error('The site template is required');
        }

        if (!isUUID(initializationData.siteTemplate)) {
            throw new Error('Invalid site template ID');
        }

        

        // End validation



        // Instantiation
        const newInstance = new Site();

        if ('id' in initializationData) {
            newInstance.id = initializationData.id;
        } else {
            newInstance.id = uuid.v4();
        }

        newInstance.archived = initializationData.archived;

        newInstance.name = initializationData.name;
        newInstance.siteTemplate = initializationData.siteTemplate;

        return newInstance;
    }

    convertToPlainObject() {
        return {
            ...this as Site,
        };
    }

    update(updateObject: any) {
        const { id, ...otherParams } = updateObject;

        for (const classKey in this) {
            if (otherParams.hasOwnProperty(classKey)) {
                this[classKey] = otherParams[classKey];
            }
        }
    }
}
